import { Link } from "react-router-dom";
import { ArrowUpRight, Layers } from "lucide-react";
import { SETS } from "../data/site";
import { Reveal } from "./motion";

const spans = [
  "md:col-span-7", "md:col-span-5",
  "md:col-span-4", "md:col-span-4", "md:col-span-4",
  "md:col-span-6", "md:col-span-6",
  "md:col-span-6", "md:col-span-6",
];

export const Sets = () => (
  <section id="sets" data-testid="sets-section" className="mx-auto max-w-[1600px] px-6 py-28 md:px-12 md:py-40">
    <Reveal>
      <h2 className="max-w-3xl font-playfair text-4xl leading-[0.95] tracking-tight text-navy md:text-6xl lg:text-7xl">
        Shop by type.
      </h2>
      <p className="mt-8 max-w-xl text-sm leading-relaxed text-navy/60 md:text-base">
        Pieces that belong together live on one page — backpacks with backpacks, bottles with bottles. Everything is
        sold individually on Etsy, so you can mix and match a set that's entirely yours.
      </p>
    </Reveal>

    <div className="mt-16 grid gap-5 md:grid-cols-12 md:mt-20">
      {SETS.map((set, i) => (
        <Reveal key={set.id} delay={Math.min(i * 0.06, 0.3)} className={spans[i]}>
          <Link
            to={`/sets/${set.id}`}
            data-testid={`set-tile-${set.id}`}
            className={`group flex h-full min-h-[22rem] flex-col justify-between border p-8 transition-transform duration-500 hover:-translate-y-2 md:p-10 ${set.bg} ${
              set.inverse ? "border-cream/25" : "border-navy/20"
            }`}
          >
            <div className="flex items-start justify-between">
              <Layers className="h-7 w-7 text-mustard" />
              <ArrowUpRight
                className={`h-7 w-7 transition-all duration-500 group-hover:translate-x-1 group-hover:-translate-y-1 ${
                  set.inverse ? "text-cream/50 group-hover:text-cream" : "text-navy/40 group-hover:text-navy"
                }`}
              />
            </div>
            <div className="mt-16 md:mt-20">
              <h3
                className={`font-playfair text-3xl leading-[1.02] tracking-tight md:text-4xl ${
                  set.inverse ? "text-cream" : "text-navy"
                }`}
              >
                {set.title}
              </h3>
              <p className={`mt-4 max-w-md text-sm leading-relaxed ${set.inverse ? "text-cream/70" : "text-navy/60"}`}>
                {set.line}
              </p>
              <div className="mt-8 flex flex-wrap items-center gap-4">
                <span
                  className={`text-[10px] font-medium uppercase tracking-[0.25em] ${
                    set.inverse ? "text-cream/50" : "text-navy/50"
                  }`}
                >
                  {set.fromCollection ? "Full range" : `${set.items.length} styles`}
                </span>
                <span
                  className={`rounded-full border px-5 py-2 text-[10px] font-medium uppercase tracking-[0.25em] transition-all duration-300 group-hover:px-6 ${
                    set.inverse ? "border-cream/40 text-cream" : "border-navy/40 text-navy"
                  }`}
                >
                  Shop the type
                </span>
              </div>
            </div>
          </Link>
        </Reveal>
      ))}
    </div>
  </section>
);
